import { useMutation, useQuery } from "@tanstack/react-query";
import { API_ENDPOINTS } from "../../../helpers/constants";
import { UserDetails } from "../../../helpers/types/common";
import apiInstance from "../../instances/apiInstance";
import { GetUsersDetailByRoleParams } from "./models";

export const useGetUserPreferredLanguage = () => {
  return useQuery({
    queryKey: ["getUserPreferredLanguage"],
    queryFn: async () => {
      const res = await apiInstance.get(API_ENDPOINTS.USER_PREFERRED_LANGUAGE);
      return res.data;
    },
    retry: false,
  });
};

export const useSaveUserPreferredLanguageMutation = () => {
  return useMutation({
    mutationFn: (preferredLanguage: string) => {
      return apiInstance.post(API_ENDPOINTS.USER_PREFERRED_LANGUAGE, {
        preferredLanguage,
      });
    },
  });
};

export const useGetUsersDetailByRoleMutation = () => {
  return useMutation({
    mutationFn: async (
      params: GetUsersDetailByRoleParams,
    ): Promise<UserDetails[]> => {
      const res = await apiInstance.post<UserDetails[]>(
        API_ENDPOINTS.USERS_DETAILS_BY_ROLE(params.countryCode),
        params.roleIds,
      );
      return res.data;
    },
  });
};
